import {Directive, ElementRef, Inject, Input, OnDestroy, OnInit} from "@angular/core";
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from "@angular/forms";


export interface ISelectOnFocusComponent extends ControlValueAccessor {
  getInputElement(): HTMLInputElement;
}

let focusedElm: HTMLElement;

@Directive({
  selector: "[selectOnFocus]"
})
export class SelectOnFocusDirective implements OnInit, OnDestroy {


  @Input() selectOnFocusDisable: boolean;

  private input: HTMLInputElement;
  private preventMouseUp: boolean;
  private valueAccessor: ISelectOnFocusComponent;

  constructor(@Inject(NG_VALUE_ACCESSOR) valueAccessors: ISelectOnFocusComponent[], private el: ElementRef) {
    this.valueAccessor = valueAccessors[0];
  }

  ngOnInit() {

    if (!this.selectOnFocusDisable) {
      const element = this.valueAccessor.getInputElement ? this.valueAccessor.getInputElement() : this.el.nativeElement;
      this.setInputElement(<HTMLInputElement>element);
    }
  }

  setEventListeners() {
    this.input.addEventListener("mouseup", (e) => {
      if (this.preventMouseUp) {
        this.preventMouseUp = false;

        e.preventDefault();
        return;
      }
    });
    this.input.addEventListener("mousedown", () => {
      if (!this.isInFocus()) {
        this.preventMouseUp = true;
      }
    });

    this.input.addEventListener("focus", () => this.setFocus());
    this.input.addEventListener("blur", () => this.clearFocus());
  }

  setInputElement(element: HTMLElement) {
    this.input = <HTMLInputElement>element;
    this.setEventListeners();
  }

  ngOnDestroy() {
    this.clearFocus();
  }

  private setFocus() {

    if (this.isInFocus()) {
      return;
    }
    focusedElm = this.input;
    // без этой задержки почему то не работает выделение при переходе клавишами TAB между различными полями
    // когда с одного поля фокус снимается и передается другому
    setTimeout(() => {

      if (!this.isInFocus()) {
        return;
      }

      if (this.input.tagName === "INPUT" || this.input.tagName === "TEXTAREA") {
        this.input.setSelectionRange(0, this.input.value.length);
      } else if (this.input.getAttribute("contenteditable") === "true") {
        const range = document.createRange();
        range.selectNodeContents(this.input);
        const sel = window.getSelection();
        sel.removeAllRanges();
        sel.addRange(range);
      }

    }, 10);

  }

  private isInFocus(): boolean {
    return focusedElm === this.input;
  }

  private clearFocus() {
    if (focusedElm === this.input) {
      focusedElm = null; // чтобы не держашло ссылку на элемент вечно
    }
  }

}

